import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import { useGetTranslations } from '~/composables/useGetTranslations';
import AzIcon from '~/components/_next/atoms/AzIcon.vue';
export default defineComponent({
  name: 'SummaryRow',
  components: {
    AzIcon: AzIcon
  },
  props: {
    fields: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  setup: function setup(props) {
    var _useMobileObserver = useMobileObserver(),
      isMobile = _useMobileObserver.isMobile;
    var _useGetTranslations = useGetTranslations(),
      translate = _useGetTranslations.translate;
    var fields = computed(function () {
      return props.fields;
    });
    var preparationTime = computed(function () {
      var _fields$value;
      return (_fields$value = fields.value) === null || _fields$value === void 0 ? void 0 : _fields$value.preparationTime;
    });
    var conservationTime = computed(function () {
      var _fields$value2;
      return (_fields$value2 = fields.value) === null || _fields$value2 === void 0 ? void 0 : _fields$value2.conservationTime;
    });
    var cost = computed(function () {
      var _fields$value3;
      return (_fields$value3 = fields.value) === null || _fields$value3 === void 0 ? void 0 : _fields$value3.cost;
    });
    var costPriceValue = computed(function () {
      var _fields$value4;
      return (_fields$value4 = fields.value) === null || _fields$value4 === void 0 ? void 0 : _fields$value4.costPriceValue;
    });
    var costPriceUnit = computed(function () {
      var _fields$value5;
      return (_fields$value5 = fields.value) === null || _fields$value5 === void 0 ? void 0 : _fields$value5.costPriceUnit;
    });
    var costSecondValue = computed(function () {
      var _fields$value6;
      return (_fields$value6 = fields.value) === null || _fields$value6 === void 0 ? void 0 : _fields$value6.costSecondValue;
    });
    var costSecondUnit = computed(function () {
      var _fields$value7;
      return (_fields$value7 = fields.value) === null || _fields$value7 === void 0 ? void 0 : _fields$value7.costSecondUnit;
    });
    var difficulty = computed(function () {
      var _fields$value8, _fields$value8$diffic, _fields$value8$diffic2;
      return (_fields$value8 = fields.value) === null || _fields$value8 === void 0 ? void 0 : (_fields$value8$diffic = _fields$value8.difficultyV2) === null || _fields$value8$diffic === void 0 ? void 0 : (_fields$value8$diffic2 = _fields$value8$diffic.fields) === null || _fields$value8$diffic2 === void 0 ? void 0 : _fields$value8$diffic2.title;
    });
    var itemList = computed(function () {
      var nbsp = String.fromCharCode(160);
      var items = [{
        label: 'rdp.preparation',
        icon: 'hourglass',
        value: "".concat(preparationTime.value),
        suffix: 'rdp.min',
        show: !!preparationTime.value
      }, {
        label: 'rdp.conservation',
        icon: 'time',
        value: "".concat(conservationTime.value),
        suffix: '',
        show: !!conservationTime.value
      }, {
        label: 'rdp.cost',
        icon: 'cost',
        value: "".concat(costPriceValue.value).concat(nbsp).concat(costPriceUnit.value || '') + (costSecondValue.value ? " / ".concat(costSecondValue.value).concat(nbsp).concat(costSecondUnit.value || '') : ''),
        suffix: '',
        show: !!costPriceValue.value,
        bold: false
      }, {
        label: 'rdp.cost',
        icon: 'cost',
        value: cost.value,
        suffix: '',
        show: !!cost.value,
        bold: false
      }, {
        label: 'rdp.difficulty',
        icon: 'microscope',
        value: difficulty.value,
        suffix: '',
        show: !!difficulty.value
      }];
      return items.filter(function (item) {
        return item.show;
      });
    });
    return {
      itemList: itemList,
      translate: translate,
      isMobile: isMobile
    };
  }
});